import React from 'react'

const AdminSpStore = () => {
  return <div>AdminSpStore</div>
}

export default AdminSpStore
